import {
  RESET_MEDICAL_TEAM_STATE,
  CASE_PARTICIPANT_EDIT_REQUEST,
  CASE_PARTICIPANT_EDIT_SUCCESS,
  CASE_PARTICIPANT_EDIT_FAILURE,
} from '../../actions/actionTypes';

const INITIAL_STATE = {
  errorMessage: '',
  status: 'no',
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CASE_PARTICIPANT_EDIT_REQUEST:
      return { ...state, status: 'requesting', errorMessage: '' };
    case CASE_PARTICIPANT_EDIT_SUCCESS:
      return { ...state, status: 'success', errorMessage: '' };
    case CASE_PARTICIPANT_EDIT_FAILURE:
      return { ...state, status: 'failed', errorMessage: action.payload };
    case RESET_MEDICAL_TEAM_STATE:
      return INITIAL_STATE;
  }

  return state;
}
